// Mock data for Marketwise Solutions trading platform

export const liveStats = {
  uptime: "99.8%",
  support: "24/7",
  activeUsers: "10K+"
};

export const heroStats = {
  dailyProfit: {
    amount: "+$842.50",
    percentage: "+12.4% today"
  },
  activeTrades: {
    count: "14 Open",
    detail: "Monitoring 150+ pairs"
  },
  winRate: {
    percentage: "94.7%",
    label: "Win Rate (AI)"
  }
};

export const tickerData = [
  { pair: "EURUSD", profit: "+$234", trades: 3 },
  { pair: "XAUUSD", profit: "+$892", trades: 7 },
  { pair: "BTCUSD", profit: "+$1,156", trades: 12 },
  { pair: "Weekly Profit", profit: "+$8,442", trades: null },
  { pair: "Win Rate", profit: "89.2%", trades: null }
];

export const todayProfit = {
  amount: "$1,247",
  percentage: "+12.4%",
  trend: "up"
};

export const howItWorksFeatures = [
  {
    title: "Market Analysis",
    description: "AI analyzes 10,000+ data points per second across multiple timeframes.",
    icon: "TrendingUp",
    color: "blue"
  },
  {
    title: "Sit & Relax",
    description: "Simply relax while AI handles the complex market calculations.",
    icon: "Coffee",
    color: "slate"
  },
  {
    title: "Broker Monitor",
    description: "Continuous monitoring of MT4/MT5 accounts for optimal entry points.",
    icon: "Activity",
    color: "purple"
  },
  {
    title: "Smart Execution",
    description: "Neural networks make optimal trading decisions with 0.1ms latency.",
    icon: "Zap",
    color: "green"
  },
  {
    title: "Your Profit",
    description: "Consistent monitoring deposited directly to your account.",
    icon: "DollarSign",
    color: "yellow"
  }
];

export const performanceStats = [
  {
    value: "94.7%",
    label: "Win Rate",
    subtitle: "Trading Accuracy",
    icon: "Target",
    color: "green"
  },
  {
    value: "0.1ms",
    label: "Execution",
    subtitle: "Lightning Speed",
    icon: "Zap",
    color: "green"
  },
  {
    value: "24/7",
    label: "Operation",
    subtitle: "Never Sleeps",
    icon: "Clock",
    color: "green"
  },
  {
    value: "10K+",
    label: "Data Points",
    subtitle: "Per Second",
    icon: "Database",
    color: "green"
  }
];

export const whyAITrading = [
  {
    title: "Removes Emotional Bias",
    description: "Execute trades based on data and logic, not fear or greed",
    icon: "Target"
  },
  {
    title: "Auto Trades with Backtested Logic",
    description: "Strategies tested on years of historical data before deployment",
    icon: "BarChart3"
  },
  {
    title: "Learns and Adapts to Market",
    description: "AI continuously optimizes strategies based on market behavior",
    icon: "Zap"
  },
  {
    title: "Consistent Performance",
    description: "Disciplined execution without deviation from proven strategies",
    icon: "Activity"
  }
];

export const whyTradeFeatures = [
  {
    title: "MT5 Compatible",
    description: "Seamlessly integrates with MetaTrader 5 platform for instant deployment",
    icon: "Plug"
  },
  {
    title: "Runs 24/7",
    description: "Never miss a trading opportunity with round-the-clock automated execution",
    icon: "Clock"
  },
  {
    title: "Adaptive AI Logic",
    description: "Machine learning algorithms that evolve with changing market conditions",
    icon: "Brain"
  },
  {
    title: "Capital Protection",
    description: "Advanced risk management with stop-loss and position sizing controls",
    icon: "Shield"
  },
  {
    title: "Beginner Friendly",
    description: "Simple setup process with comprehensive guides and 24/7 support",
    icon: "Users"
  },
  {
    title: "High Performance",
    description: "Backtested strategies with proven track records across market cycles",
    icon: "TrendingUp"
  }
];

export const deepDiveFeatures = [
  {
    title: "Market Analysis",
    description: "Advanced neural networks process vast amounts of market data in real-time, identifying patterns and opportunities that human traders might miss.",
    icon: "TrendingUp",
    color: "blue"
  },
  {
    title: "Sit & Relax",
    description: "Our AI handles all the heavy lifting - from market analysis to trade execution. You focus on your life while we focus on your profits.",
    icon: "Coffee",
    color: "slate"
  },
  {
    title: "Broker Monitor",
    description: "24/7 monitoring of your MT4/MT5 broker accounts ensures optimal trade timing and risk management across all your positions.",
    icon: "Activity",
    color: "purple"
  }
];

export const botRecommendations = {
  1000: {
    name: "Starter Edge",
    expectedProfit: "5-8% monthly",
    pair: "EURUSD",
    risk: "Low"
  },
  5000: {
    name: "Golden Opportunity",
    expectedProfit: "8-12% monthly",
    pair: "XAUUSD",
    risk: "Medium"
  },
  10000: {
    name: "Crypto Surge",
    expectedProfit: "12-18% monthly",
    pair: "BTCUSD",
    risk: "Medium-High"
  },
  25000: {
    name: "Multi-Pair Pro",
    expectedProfit: "10-15% monthly",
    pair: "EURUSD, XAUUSD, BTCUSD",
    risk: "Balanced"
  },
  50000: {
    name: "Institutional Alpha",
    expectedProfit: "15-22% monthly",
    pair: "All Pairs + Indices",
    risk: "Aggressive"
  }
};

export const pricingPlans = [
  {
    name: "Starter",
    description: "Perfect for beginners exploring AI trading",
    price: "Contact for Pricing",
    features: [
      "1 Trading Bot (EURUSD)",
      "Basic Strategy",
      "MT5 Integration",
      "Email Support",
      "Monthly Performance Reports",
      "Basic Risk Management"
    ],
    recommended: false
  },
  {
    name: "Advanced",
    description: "Most popular for serious traders",
    price: "Contact for Pricing",
    features: [
      "3 Trading Bots (Multi-Pair)",
      "Advanced AI Strategies",
      "MT5 Integration",
      "Priority 24/7 Support",
      "Real-time Analytics Dashboard",
      "Advanced Risk Controls",
      "Weekly Strategy Updates",
      "Dedicated Account Manager"
    ],
    recommended: true
  },
  {
    name: "Institutional",
    description: "Enterprise solutions for firms",
    price: "Custom Pricing",
    features: [
      "Unlimited Trading Bots",
      "Custom AI Development",
      "White-Label Options",
      "Dedicated Support Team",
      "API Access",
      "Custom Integrations",
      "On-Premise Deployment",
      "SLA Guarantee"
    ],
    recommended: false
  }
];

export const blogPosts = [
  {
    title: "Why Gold Bots Are Trending in 2025",
    excerpt: "Discover why XAUUSD automated trading is becoming the preferred choice for risk-averse investors",
    date: "Dec 15, 2024",
    readTime: "5 min read",
    category: "Market Insights"
  },
  {
    title: "Best Capital Size for AI Trading",
    excerpt: "Learn the optimal account size to maximize returns while managing risk effectively",
    date: "Dec 10, 2024",
    readTime: "7 min read",
    category: "Trading Guide"
  },
  {
    title: "MT5 vs MT4 for Auto Trading in India",
    excerpt: "A comprehensive comparison to help you choose the right platform for automated trading",
    date: "Dec 5, 2024",
    readTime: "6 min read",
    category: "Platform Review"
  }
];

export const clientReviews = [
  {
    id: 1,
    name: "Ahmed Al Maktoum",
    location: "Dubai, UAE",
    role: "Private Investor",
    rating: 5,
    review: "Marketwise Solutions has completely transformed my trading approach. The AI-powered bots are incredibly sophisticated and have consistently delivered excellent returns. As someone who travels frequently for business, having a 24/7 automated system gives me peace of mind.",
    profit: "+127% in 6 months",
    avatar: "AM"
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Mumbai, India",
    role: "Entrepreneur",
    rating: 5,
    review: "I was skeptical about automated trading at first, but Marketwise Solutions proved me wrong. The customer support team is exceptional, and the results speak for themselves. I've been able to grow my investment portfolio significantly while focusing on my business.",
    profit: "+89% in 4 months",
    avatar: "PS"
  },
  {
    id: 3,
    name: "Mohammed Al Rashid",
    location: "Abu Dhabi, UAE",
    role: "Investment Manager",
    rating: 5,
    review: "The institutional plan is perfect for managing multiple accounts. The white-label option allowed us to offer AI trading to our clients seamlessly. The advanced risk controls and real-time analytics are exactly what we needed for our firm.",
    profit: "+156% annually",
    avatar: "MR"
  },
  {
    id: 4,
    name: "Rajesh Kumar",
    location: "Bangalore, India",
    role: "Software Engineer",
    rating: 5,
    review: "As a tech professional, I appreciate the sophistication behind Marketwise's AI algorithms. The backtested strategies and transparent performance metrics give me confidence. It's like having a professional trader working for me around the clock.",
    profit: "+94% in 5 months",
    avatar: "RK"
  },
  {
    id: 5,
    name: "Fatima Al Zaabi",
    location: "Sharjah, UAE",
    role: "Financial Consultant",
    rating: 5,
    review: "Marketwise Solutions stands out for their professionalism and results. The platform is beginner-friendly yet powerful enough for experienced traders. I've recommended it to several of my clients, and they're all extremely satisfied.",
    profit: "+112% in 7 months",
    avatar: "FZ"
  },
  {
    id: 6,
    name: "Arjun Patel",
    location: "Delhi, India",
    role: "Business Owner",
    rating: 5,
    review: "The Advanced plan has been a game-changer for me. Multi-pair trading with AI strategies has diversified my portfolio beautifully. The weekly updates and dedicated account manager make this service worth every penny. Highly recommend!",
    profit: "+103% in 6 months",
    avatar: "AP"
  }
];
